import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { PurchaseOrderHistoryEntry } from '../types/purchaseOrder';
import { formatDate } from '../utils';

interface CommentsSectionProps {
  comments: PurchaseOrderHistoryEntry[];
  onAddComment: (comment: string) => Promise<void>;
}

const CommentsSection: React.FC<CommentsSectionProps> = ({ comments, onAddComment }) => {
  const [comment, setComment] = useState('');
  const [addingComment, setAddingComment] = useState(false);

  const handleAddComment = async () => {
    if (!comment.trim()) return;
    setAddingComment(true);
    try {
      await onAddComment(comment);
      setComment('');
    } finally {
      setAddingComment(false);
    }
  };

  return (
    <div>
      <h4>Events</h4>
      {comments && comments.length > 0 ? (
        <DataTable value={comments} responsiveLayout="scroll">
          <Column field="timestamp" header="Timestamp" body={(rowData: PurchaseOrderHistoryEntry) => formatDate(rowData.timestamp)} />
          <Column field="action" header="Action" />
          <Column field="user" header="User" />
          <Column field="details" header="Details" body={(rowData: PurchaseOrderHistoryEntry) => rowData.details || '-'} />
        </DataTable>
      ) : (
        <p>No comments available.</p>
      )}
      <div className="flex align-items-start mb-3 mt-3">
        <InputTextarea
          rows={3}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Add a comment..."
          className="mr-2 flex-grow-1"
        />
        <Button
          label="Add Comment"
          icon="pi pi-plus"
          onClick={handleAddComment}
          disabled={addingComment || !comment.trim()}
          loading={addingComment}
        />
      </div>
    </div>
  );
};

export default CommentsSection;